function combineSections() {

  const firstSection = document.querySelector(
    '#shopify-section-template--26695501349144__featured_faq_fk8YwE'
  );

  const secondSection = document.querySelector(
    '#shopify-section-template--26695501349144__warrior_guarantee_DcdFhk'
  );

  const thirdSection = document.querySelector(
    '#shopify-section-template--26695501349144__related_products'
  );

  if (firstSection) {

    // move second section inside first
    if (secondSection) {
      firstSection.appendChild(secondSection);
    }

    // move third section inside first
    if (thirdSection) {
      firstSection.appendChild(thirdSection);
    }
  }
}

document.addEventListener('DOMContentLoaded', combineSections);

// Shopify Theme Editor Support
document.addEventListener(
  'shopify:section:load',
  combineSections
);


document.addEventListener("DOMContentLoaded", function() {
  const testimonialSwiper = new Swiper(".testimonialSwiper", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    grabCursor: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640:  { slidesPerView: 1.5, spaceBetween: 20 },
      768:  { slidesPerView: 2,   spaceBetween: 24 },
      1024: { slidesPerView: 3,   spaceBetween: 24 }
    }
  });

  // Dynamic Read More/Less Toggler
  document.querySelectorAll('.custom-testimonials .read-more-btn').forEach(button => {
    button.addEventListener('click', function() {
      const textContainer = this.previousElementSibling;
      
      if (textContainer.classList.contains('content-truncated')) {
        textContainer.classList.remove('content-truncated');
        textContainer.classList.add('content-expanded');
        this.textContent = 'Read Less';
        this.setAttribute('aria-expanded', 'true');
      } else {
        textContainer.classList.remove('content-expanded');
        textContainer.classList.add('content-truncated');
        this.textContent = 'Read More';
        this.setAttribute('aria-expanded', 'false');
      }
      
      // Tells Swiper engine to rebuild viewport calculations dynamically
      testimonialSwiper.update();
    });
  });
});


/**
 * Custom Product Swiper Engine Runtime
 * Scopes carousel selectors dynamically per section id boundary.
 */
function initCustomProductSwiper() {
  const customSwiperSections = document.querySelectorAll('.sec__custom-product-swiper');
  
  customSwiperSections.forEach((section) => {
    // Prevent duplicated swiper attachments
    if (section.classList.contains('swiper-initialized')) return;
    
    const sliderContainer = section.querySelector(".coreProductSwiper");
    if (!sliderContainer) return;

    new Swiper(sliderContainer, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      grabCursor: true,
      freeMode: false,
      navigation: {
        nextEl: section.querySelector(".swiper-btn-next"),
        prevEl: section.querySelector(".swiper-btn-prev"),
      },
      scrollbar: {
        el: section.querySelector(".custom-swiper-progressbar"),
        dragEl: section.querySelector(".custom-swiper-progressbar-drag"),
        draggable: true,
      },
      breakpoints: {
        480:  { slidesPerView: 1.85, spaceBetween: 16 },
        750:  { slidesPerView: 2.6,  spaceBetween: 20 },
        1024: { slidesPerView: 4,    spaceBetween: 24 }
      }
    });

    section.classList.add('swiper-initialized');
  });
}

// Initial Call on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomProductSwiper);
} else {
  initCustomProductSwiper();
}

// Support Theme Customizer live editor frame previews re-renders
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.classList.contains('sec__custom-product-swiper') || event.target.querySelector('.sec__custom-product-swiper')) {
    initCustomProductSwiper();
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const bundle = document.querySelector('#shopify-section-template--26763036164376__bundle_swiper_zjyf4h');
  const promo = document.querySelector('#shopify-section-template--26763036164376__custom_promo_banner_36JTbQ');

  if (bundle && promo) {
    bundle.appendChild(promo);
  }
});